var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "device-setting-preview-component",
      class: { inRoom: !_vm.isDevicetest },
      attrs: { "data-grm-comp": "DeviceSettingPreview" },
    },
    [
      _c("div", { staticClass: "device-setting-preview" }, [
        _c("div", { staticClass: "device-set-preview" }, [
          _vm.isMobile || !_vm.isDevicetest
            ? _c(
                "div",
                {
                  staticClass: "device-set-preview-header",
                  class: { screenSetting: !_vm.isDevicetest },
                },
                [
                  !_vm.isOpenDepsContainer
                    ? _c(
                        "div",
                        { staticClass: "device-set-preview-title-wrapper" },
                        [
                          _vm.isDevicetest
                            ? _c("a", {
                                staticClass: "back-btn",
                                attrs: { href: _vm.homeUrl },
                              })
                            : _vm._e(),
                          !_vm.isDevicetest
                            ? _c("button", {
                                staticClass: "close-btn",
                                on: { click: _vm.onClose },
                              })
                            : _vm._e(),
                          _vm.isDevicetest
                            ? _c("div", [_vm._v(_vm._s(_vm.roomTitle))])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("camstudy.control.screenSetting")
                                  )
                                ),
                              ]),
                          _vm.isDevicetest
                            ? _c("a", {
                                staticClass: "ico-help-white",
                                attrs: {
                                  href: "https://webchat.thecloudgate.io/webChat?brandKey=MUxOPwt-6RJvxjfghABUmA&channelType=scenario&scenarioId=MzI3OQ",
                                  target: "_blank",
                                },
                              })
                            : !_vm.isDevicetest
                            ? _c(
                                "button",
                                {
                                  staticClass: "save-content",
                                  on: { click: () => _vm.saveCoordi() },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.save")))]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm.isOpenDepsContainer
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "device-set-preview-title-wrapper profile-modify",
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("camstudy.preview.profile.title"))
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "device-set-preview-body" }, [
            _c(
              "div",
              {
                staticClass:
                  "device-set-preview-video-container overflow-hidden",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isOpenDepsContainer,
                        expression: "!isOpenDepsContainer",
                      },
                    ],
                    staticClass:
                      "device-set-preview-video-wrapper relative overflow-hidden",
                    class: [
                      { error: _vm.selectedDevice.video.state === "error" },
                    ],
                  },
                  [
                    _vm.renderCanvas
                      ? _c("div", {
                          ref: "canvasRenderLayer",
                          staticClass: "device-set-preview-video",
                          class: {
                            mirror: _vm.selectedDevice.video.usePreviewMirror,
                          },
                        })
                      : _c("video", {
                          ref: "preview_video",
                          staticClass:
                            "device-set-preview-video bg-black previewVideo",
                          class: {
                            mirror: _vm.selectedDevice.video.usePreviewMirror,
                          },
                          attrs: {
                            autoplay: "",
                            muted: "",
                            "webkit-playsinline": "",
                            playsinline: "",
                          },
                          domProps: { muted: true },
                        }),
                    _c(
                      "div",
                      {
                        ref: "videoBlurControl",
                        staticClass: "arrow-button",
                        staticStyle: { display: "none" },
                        on: {
                          pointerdown: function ($event) {
                            $event.preventDefault()
                            return _vm.onClickBlurFilterButton.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 100 100",
                              width: "30",
                              height: "30",
                            },
                          },
                          [
                            _c("polygon", {
                              attrs: {
                                points: "50,10 35,25 65,25",
                                fill: "black",
                              },
                            }),
                            _c("polygon", {
                              attrs: {
                                points: "50,90 35,75 65,75",
                                fill: "black",
                              },
                            }),
                            _c("polygon", {
                              attrs: {
                                points: "10,50 25,35 25,65",
                                fill: "black",
                              },
                            }),
                            _c("polygon", {
                              attrs: {
                                points: "90,50 75,35 75,65",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "v-bg",
                        class: { "no-cam": _vm.cameraOff },
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cameraOff,
                              expression: "cameraOff",
                            },
                          ],
                          staticClass: "pointer-events-none",
                          style: {
                            width: "96px",
                            height: "96px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          },
                          attrs: { src: _vm.getUserImage },
                        }),
                      ]
                    ),
                    _c("div", { ref: "canvas-setting-ref" }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.blurVideo.isOpen,
                            expression: "!blurVideo.isOpen",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "determination-message",
                            on: { click: _vm.onOpenDetermination },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.myMsg ||
                                  _vm.$t("camstudy.preview.determination.enter")
                              )
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "video-preview-stopwatch",
                            style: _vm.getStopWatchStyle,
                          },
                          [_vm._v("00:00:00")]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.blurVideo.isOpen,
                            expression: "!blurVideo.isOpen",
                          },
                        ],
                        staticClass: "device-container shadow-rectangle",
                      },
                      [
                        _c("div", { staticClass: "device-info-container" }, [
                          _c("div", {
                            staticClass: "device-info-image camera",
                            class: {
                              active: _vm.isCameraStatus("on"),
                              inactive: _vm.isCameraStatus("off"),
                              notExist: _vm.isCameraStatus("notExist"),
                            },
                            on: { click: _vm.onToggleUserDeviceStatus },
                          }),
                          _c("div", { staticClass: "device-info-message" }, [
                            _vm._v(_vm._s(_vm.$t("common.device.camera"))),
                          ]),
                        ]),
                        _vm.isMobile
                          ? _c(
                              "div",
                              { staticClass: "device-info-container" },
                              [
                                _c("div", {
                                  staticClass: "device-info-image transition",
                                  on: { click: _vm.toggleCamera },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "device-info-message" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("camstudy.preview.switch"))
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "device-info-container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "relative",
                              on: { click: _vm.onOpenDepsContainer },
                            },
                            [
                              _vm.userProfile.profileImageUrl
                                ? _c("img", {
                                    staticClass: "device-info-image",
                                    attrs: {
                                      src: _vm.userProfile.profileImageUrl,
                                    },
                                  })
                                : _c("div", { staticClass: "user-image-none" }),
                              _c("div", { staticClass: "modify-profile" }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              ref: "device-info-nickname",
                              staticClass: "device-info-message",
                            },
                            [_vm._v(_vm._s(_vm.userProfile.nickname))]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        _vm.selectedDevice.video.state === "loading"
                          ? _c("GrmLoadingCircle", {
                              staticClass:
                                "rounded-lg bg-black bg-opacity-50 absolute inset-0",
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.inProgressUpload
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "device-set-preview-video-wrapper profile-modify relative",
                      },
                      [_c("div", { staticClass: "loading-spinner" })]
                    )
                  : _vm.isOpenDepsContainer && !_vm.isShowCropper
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "device-set-preview-video-wrapper profile-modify justify-center relative",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "image-profile-container relative",
                            on: { click: _vm.onOpenImageSelect },
                          },
                          [
                            _vm.editUserProfile.profileImageUrl
                              ? _c("img", {
                                  staticClass: "profile-image",
                                  attrs: {
                                    src: _vm.editUserProfile.profileImageUrl,
                                    alt: "",
                                  },
                                })
                              : _c("div", {
                                  staticClass:
                                    "user-image-none profile-image-none",
                                }),
                            _c("div", { staticClass: "modify-profile-image" }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "profile-modify-input-container" },
                          [
                            _c("div", { staticClass: "profile-name-temp" }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.editUserProfile.nickname,
                                  expression: "editUserProfile.nickname",
                                },
                              ],
                              staticClass: "profile-name-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.editUserProfile.nickname },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.editUserProfile,
                                    "nickname",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("div", {
                              staticClass: "profile-name-change-icon",
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex gap-2.5 w-full profile-button-container",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "profile-button cancel",
                                on: { click: _vm.onCloseDepsContainer },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "profile-button save",
                                attrs: {
                                  disabled: _vm.isLoadingChangeUserProfile,
                                },
                                on: { click: _vm.onSaveUserProfile },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.save")))]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm.isOpenDepsContainer && _vm.isShowCropper
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "device-set-preview-video-wrapper profile-modify flex-start relative",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "cropper-container" },
                          [
                            _c("cropper", {
                              staticClass: "cropper",
                              attrs: {
                                src: _vm.selectedImage?.path,
                                options: { aspectRatio: 338 / 273 },
                                "stencil-props": { aspectRatio: 1 },
                              },
                              on: { change: _vm.onChangeCropImage },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex gap-2.5 w-full profile-button-container",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "profile-button cancel",
                                on: { click: _vm.onCancelCropImage },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "profile-button save",
                                on: { click: _vm.onCompleteCropImage },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.complete")))]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "setting-container" },
              [
                _c("div", { staticClass: "coordi-options-container" }, [
                  _vm.isDevicetest
                    ? _c(
                        "button",
                        {
                          class: {
                            isActive: _vm.coordiComponent === "roomInfo",
                          },
                          attrs: { value: "roomInfo" },
                          on: { click: _vm.changeCoordiComponent },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("camstudy.preview.options.info"))
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      class: { isActive: _vm.coordiComponent === "sticker" },
                      attrs: { value: "sticker" },
                      on: { click: _vm.changeCoordiComponent },
                    },
                    [_vm._v(_vm._s(_vm.$t("camstudy.preview.options.sticker")))]
                  ),
                  _c(
                    "button",
                    {
                      class: { isActive: _vm.coordiComponent === "stopWatch" },
                      attrs: { value: "stopWatch" },
                      on: { click: _vm.changeCoordiComponent },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.preview.options.stopwatch"))
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: {
                        isActive: _vm.coordiComponent === "CameraScreenSetting",
                      },
                      attrs: { value: "CameraScreenSetting" },
                      on: { click: _vm.changeCoordiComponent },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.preview.options.cameraSetting"))
                      ),
                    ]
                  ),
                  !_vm.isMobile
                    ? _c(
                        "button",
                        {
                          class: {
                            isActive: _vm.coordiComponent === "DeviceSetting",
                          },
                          attrs: { value: "DeviceSetting" },
                          on: { click: _vm.changeCoordiComponent },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("camstudy.preview.options.deviceSetting")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c(_vm.coordiComponent, {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.coordiComponent,
                      expression: "coordiComponent",
                    },
                  ],
                  tag: "component",
                  attrs: {
                    "room-info": _vm.roomInfo,
                    camStudyRoomInfoProps: _vm.camStudyRoomInfoProps,
                    isDevicetest: _vm.isDevicetest,
                    userProfile: _vm.userProfile,
                    isOpenDeps: _vm.isOpenDeps,
                  },
                  on: {
                    saveCoordi: _vm.saveCoordi,
                    onChangeStopWatchImage: _vm.onChangeStopWatchImage,
                    toggleTransitionCamera: _vm.toggleTransitionCamera,
                    onOpenDeps: _vm.onOpenDeps,
                  },
                }),
                _vm.isOpenDeps && _vm.coordiComponent === "CameraScreenSetting"
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "default-btn-previous join-request-btn join-room-btn",
                        class: { innerRoom: !_vm.isDevicetest },
                        on: { click: _vm.onCloseDeps },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.prev")))]
                    )
                  : _vm.isDevicetest
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "default-btn join-request-btn join-room-btn",
                        on: { click: _vm.join },
                      },
                      [_vm._v(_vm._s(_vm.joinText))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm.isOpenDetermination
          ? _c(
              "div",
              {
                staticClass: "determination-input-container",
                class: { isDeviceTest: _vm.isDeviceTest },
              },
              [
                _c("div", { staticClass: "determination-body" }, [
                  _c("h4", { staticClass: "determination-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("camstudy.preview.determination.title"))
                    ),
                  ]),
                  _c("input", {
                    ref: "myMsgInput",
                    staticClass: "determination-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.myMsg },
                  }),
                ]),
                _c("div", { staticClass: "determination-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "determination-button cancel",
                      on: { click: _vm.onCloseDetermination },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "determination-button ok",
                      on: { click: _vm.onCheckDetermination },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.confirm")))]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm.isOpenImageSelect
        ? _c(
            "div",
            {
              staticClass: "image-select-cover",
              on: { click: _vm.onCloseImageSelect },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-select-container",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "image-select-button relative",
                      on: { click: _vm.onChangeFileData },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("camstudy.preview.profile.image.select")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "image-select-button",
                      on: { click: _vm.onChangeDefaultProfileImage },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.preview.profile.image.default"))
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }